import { IconButton, Tooltip } from "@mui/material";

const ActionButton = ({ icon: Icon, tooltip, onClick }) => {
  return (
    <Tooltip title={tooltip}>
      <IconButton
        aria-label={tooltip?.toLowerCase()}
        onClick={onClick}
        size="small"
        sx={{ backgroundColor: "#F6F6F6" }}
      >
        <Icon fontSize="small" />
      </IconButton>
    </Tooltip>
  );
};

export default ActionButton;
